// extracted by mini-css-extract-plugin
export var button = "_ky-0";
export var donut = "_ky-1";
export var donutFill = "_ky-3";
export var donutTrack = "_ky-2";